import { render, staticRenderFns } from "./InviteNotification.vue?vue&type=template&id=6509795e"
import script from "./InviteNotification.vue?vue&type=script&lang=js"
export * from "./InviteNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports